const baseurl = (window._env_ && window._env_.REACT_APP_BASE_AUTH_URL) || process.env.REACT_APP_BASE_AUTH_URL;

export default baseurl;